import { ScheduleDraft } from "./scheduleDraft";
import { moveScheduleDraftTermStart } from "./scheduleDraftRows";

export interface MigratedSchedulePrevious {
    holdingAccountId: string | null;
    termStart: string;
}

/** What turning "Migrated schedule" on changes, so turning it off can put it back. */
export function enterMigratedScheduleDraft(options: {
    draft: ScheduleDraft;
    holdingAccountId: string | null;
    bookkeepingStartDate: string;
}): ScheduleDraft {
    const { draft, holdingAccountId, bookkeepingStartDate } = options;
    return moveScheduleDraftTermStart({
        draft: {
            ...draft,
            holdingAccountId: holdingAccountId ?? draft.holdingAccountId,
        },
        termStart: bookkeepingStartDate,
    });
}

export function leaveMigratedScheduleDraft(options: {
    draft: ScheduleDraft;
    previous: MigratedSchedulePrevious;
}): ScheduleDraft {
    const { draft, previous } = options;
    return moveScheduleDraftTermStart({
        draft: { ...draft, holdingAccountId: previous.holdingAccountId },
        termStart: previous.termStart,
    });
}
